import { Injectable } from '@angular/core';
import { ClinicManager } from '../../data/models/ClinicManager';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly STORAGE_KEY = 'currentUser'

  isLoggedIn(): boolean {
    return !!localStorage.getItem(this.STORAGE_KEY)
  }

  getCurrentManager(): ClinicManager | null {
    const stored = localStorage.getItem(this.STORAGE_KEY)
    if (!stored) return null
    try {
      return JSON.parse(atob(stored))
    } catch {
      return null
    }
  }

  setCurrentManager(manager: ClinicManager): void {
    localStorage.setItem(this.STORAGE_KEY, btoa(JSON.stringify(manager)))
  }

  clearSession(): void {
    localStorage.removeItem(this.STORAGE_KEY)
    sessionStorage.clear()
  }
}
